import { createStore, combineReducers } from 'redux';
import bookingsReducer from './reducer';

const rootReducer = combineReducers({
  bookings: bookingsReducer,
});

export const store = createStore(rootReducer);
